import React from 'react';
import { Container, Row, Col, Input, Button } from 'reactstrap';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  PieChart,
  Pie,
  Cell
} from 'recharts';
import './graficos.styles.css';
import { colors } from '../../app/common/util/color.const.util';
import SelectComponent from '@componentes/select/select.component';
import IntlMessage from '../../helpers/intlMessage';
import { injectIntl } from 'react-intl';

const GraficosMainPage = (props) => {
   const { messages }= props.intl;

  return (
    <div>
      <Container fluid className='mv-workspace-container'>
        <Row>          
          <Col>
            <Row className='mv-graficos-filtro'>
              <Col sm={'auto'}>
                <h2 className='title-citologia'><IntlMessage id = "dashboards.graphics.graphics"/></h2>
              </Col>
              <Col sm={4}>
                <SelectComponent
                  onChange={e => props.cenarioChange(e.value)}
                  options={[
                    {
                      label: <IntlMessage id = "dashboards.graphics.reportsDelivered"/>,
                      value: '1'
                    },
                    {
                      label: <IntlMessage id = "dashboards.graphics.historyNonCompliance"/>,
                      value: '2'
                    },
                    {
                      label: <IntlMessage id = "dashboards.graphics.averageTime"/>,
                      value: '3'
                    },
                    // {
                    //   label: 'CANCELAMENTOS POR ETAPAS',
                    //   value: '4',
                    // },
                    {
                      label: <IntlMessage id = "dashboards.graphics.materialProductivity"/>,
                      value: '5'
                    },
                    {
                      label: <IntlMessage id = "dashboards.graphics.macroscopicMap"/>,
                      value: '6'
                    }
                  ]}
                  placeholder={messages["dashboards.graphics.selectScenery"]}
                />
              </Col>
              <Col sm='auto' style={{ padding: 0 }}>
                <Row>
                  <div className='label-data'><IntlMessage id = "dashboards.graphics.initial"/></div>
                  <Input
                    type='date'
                    onChange={e =>
                      props.periodoChange('periodode', e.currentTarget.value)
                    }
                    value={props.getDate('periodode')}
                  />
                  <div className='label-data'><IntlMessage id = "dashboards.graphics.last"/></div>
                  <Input
                    type='date'
                    onChange={e =>
                      props.periodoChange('periodoate', e.currentTarget.value)
                    }
                    value={props.getDate('periodoate')}
                  />
                </Row>
              </Col>
              <Col sm='auto'>
                <Button color='info' onClick={props.gerar}>
                  <IntlMessage id = "dashboards.graphics.generate"/>
                </Button>
              </Col>
            </Row>
            <div className='mv-graficos-resultado'>
              {props.data.length > 0 && props.cenario === '1' && (
                <Row>
                  <Col>
                    <ResponsiveContainer width='100%' height={400}>
                      <BarChart data={props.data}>
                        <CartesianGrid strokeDasharray='3 3' />
                        <XAxis dataKey='name' />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar
                          dataKey='value'
                          name={<IntlMessage id = "dashboards.graphics.reportsDeliveredMonth"/>}
                          fill='#8884d8'
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </Col>
                </Row>
              )}
              {props.data.length > 0 && props.cenario === '2' && (
                <Row>
                  <Col>
                    <ResponsiveContainer height={400}>
                      <BarChart data={props.data}>
                        <CartesianGrid fontSize={11} strokeDasharray='3 3' />
                        <XAxis dataKey='Name' hide={true} />
                        <YAxis />
                        <Tooltip
                          labelStyle={{ fontSize: '11px', fontWeight: 600 }}
                          itemStyle={{ fontSize: '11px' }}
                        />
                        <Legend />
                        {props.data.find(x => x.MATERIAL) !== undefined && (
                          <Bar dataKey='MATERIAL' stackId='a' fill='#676AE5' />
                        )}
                        {props.data.find(x => x.CONGELACAO) !== undefined && (
                          <Bar
                            dataKey='CONGELACAO'
                            stackId='a'
                            fill='#0B0D4C'
                          />
                        )}
                        {props.data.find(x => x.MACRO) !== undefined && (
                          <Bar dataKey='MACRO' stackId='a' fill='#628EB3' />
                        )}
                        {props.data.find(x => x.MICRO) !== undefined && (
                          <Bar dataKey='MICRO' stackId='a' fill='#A3B2BF' />
                        )}
                        {props.data.find(x => x.HISTO) !== undefined && (
                          <Bar dataKey='HISTO' stackId='a' fill='#664C24' />
                        )}
                        {props.data.find(x => x.IMUNO) !== undefined && (
                          <Bar dataKey='IMUNO' stackId='a' fill='#E59167' />
                        )}
                        {props.data.find(x => x.FISH) !== undefined && (
                          <Bar dataKey='FISH' stackId='a' fill='#3F5C73' />
                        )}
                        {props.data.find(x => x.CISH) !== undefined && (
                          <Bar dataKey='CISH' stackId='a' fill='#FAFF80' />
                        )}
                        {props.data.find(x => x.PCR) !== undefined && (
                          <Bar dataKey='PCR' stackId='a' fill='#A07CBF' />
                        )}
                        {props.data.find(x => x.CONCLUSAO) !== undefined && (
                          <Bar dataKey='CONCLUSAO' stackId='a' fill='#67E5DD' />
                        )}
                        {props.data.find(x => x.NOTAS) !== undefined && (
                          <Bar dataKey='NOTAS' stackId='a' fill='#BC96A4' />
                        )}

                        {props.data.find(x => x.ERRATA) !== undefined && (
                          <Bar dataKey='ERRATA' stackId='a' fill='#BC96A4' />
                        )}
                        {props.data.find(x => x.LAMINA_CITOLOGIA) !==
                          undefined && (
                          <Bar
                            dataKey='LAMINA_CITOLOGIA'
                            stackId='a'
                            fill='#FFF6D9'
                          />
                        )}
                        {props.data.find(x => x.LAMINA_CONGELACAO) !==
                          undefined && (
                          <Bar
                            dataKey={<IntlMessage id = "dashboards.graphics.freezingBlade"/>}
                            stackId='a'
                            fill='#B36264'
                          />
                        )}
                        {props.data.find(x => x.MAPA) !== undefined && (
                          <Bar dataKey='MAPA' stackId='a' fill='#4C420B' />
                        )}
                        {props.data.find(x => x.TECNICA) !== undefined && (
                          <Bar dataKey='TECNICA' stackId='a' fill='#8884d8' />
                        )}
                      </BarChart>
                    </ResponsiveContainer>
                  </Col>
                </Row>
              )}
              {props.data.length > 0 && props.cenario === '3' && (
                <Row>
                  <Col>
                    <ResponsiveContainer height={500}>
                      <PieChart>
                        <Pie
                          dataKey='duracao'
                          nameKey='etapa'
                          data={props.data}
                          labelLine={true}
                          label={({
                            cx,
                            cy,
                            midAngle,
                            innerRadius,
                            outerRadius,
                            label
                          }) => {
                            const RADIAN = Math.PI / 180;
                            const radius =
                              innerRadius + (outerRadius - innerRadius) * 1.2;
                            const x =
                              cx + radius * Math.cos(-midAngle * RADIAN);
                            const y =
                              cy + radius * Math.sin(-midAngle * RADIAN);

                            return (
                              <text
                                style={{ fontSize: '13px', fontWeight: 'bold' }}
                                x={x}
                                y={y}
                                fill='black'
                                textAnchor={x > cx ? 'start' : 'end'}
                                dominantBaseline='central'
                              >
                                {`${label}`}
                              </text>
                            );
                          }}
                        >
                          {props.data.map((e, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={colors[index % colors.length]}
                            />
                          ))}
                        </Pie>

                        <Legend />
                      </PieChart>
                    </ResponsiveContainer>
                  </Col>
                </Row>
              )}
              {props.data.length > 0 && props.cenario === '4' && (
                <Row>
                  <Col>
                    <ResponsiveContainer height={500}>
                      <PieChart>
                        <Pie dataKey='value' nameKey='name' data={props.data}>
                          {props.data.map((e, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={colors[index % colors.length]}
                            />
                          ))}
                        </Pie>
                        <Tooltip />
                        <Legend />
                      </PieChart>
                    </ResponsiveContainer>
                  </Col>
                </Row>
              )}
              {props.data !== undefined &&
                props.data.data !== undefined &&
                props.data.data.length > 0 &&
                (props.cenario === '5' || props.cenario === '6') && (
                  <Row>
                    <Col>
                     { props.cenario === '5' && 
                        <h4 className='tituloGraficoProdutividade'>
                           <IntlMessage id = "dashboards.graphics.totalOfBottles"/>
                        </h4> 
                     }
                     { props.cenario === '6' && 
                       <h4 className='tituloGraficoProdutividade'>
                         <IntlMessage id = "dashboards.graphics.totalOfCassetes"/>
                       </h4> 
                     }
                      <ResponsiveContainer height={500}>
                        <BarChart
                          width={600}
                          height={300}
                          data={props.data.data}
                          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                        >
                          <CartesianGrid strokeDasharray='3 3' />
                          <XAxis dataKey='name' />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          {props.data.dataKey.map((el, i) => (
                            <Bar
                              key={i}
                              dataKey={el}
                              stackId='a'
                              fill={colors[i % colors.length]}
                            />
                          ))}
                        </BarChart>
                      </ResponsiveContainer>
                    </Col>
                  </Row>
                )}
              {props.data !== undefined &&
                props.data.data !== undefined &&
                props.data.data.length === 0 &&
                (props.cenario === '5' || props.cenario === '6') && (
                  <Row>
                    <span className='nenhumaInformacao'>
                      <IntlMessage id = "dashboards.graphics.noDataPeriod"/>
                    </span>
                  </Row>
                )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default injectIntl (GraficosMainPage);



// WEBPACK FOOTER //
// ./src/pages/graficos/graficos.page.js